module.exports = __webpack_public_path__ + "img/强.a0e172d3.gif";